import * as React from 'react';
import _ from 'lodash';
import { localPx2rem } from '@mpc/common/src/utils';
import { Modal } from '@bedrock/components';

export interface ModalTipProps {
  modalType?: 'info' | 'success' | 'error' | 'warning' | 'confirm';
  modalConfig: typeof Modal['confirm'];
  componentClass: string | keyof React.ReactHTML | React.ComponentType<any>;
  onBeforeShow?: () => Promise<any>;
  [key: string]: any
}

export default (props) => {
  const { modalType = 'confirm', modalConfig, onBeforeShow, componentClass, children, ...rest } = props;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {

    event.stopPropagation && event.stopPropagation();
    
    if(Modal[modalType]) {
      if (onBeforeShow) {
        onBeforeShow().then(() => {
          Modal[modalType]({
            width: 400,
            ...modalConfig
          });
        });
      } else {
        Modal[modalType]({
          width: 400,
          ...modalConfig
        });
      }
    }
  }

  return React.createElement(
    componentClass,
    {
      onClick: handleClick,
      ...rest
    },
    children
  )
}
